module.exports = __webpack_public_path__ + "static/acupun_1_xl-374aa1e772245893e4adce1c5b4411bf.png";